import LogoMark from './LogoMark';

export default function SiteHeader() {
    return (
        <header className="client-site-header pt-8 sm:py-8 sticky top-0 transform -translate-y-8 sm:translate-y-0 pointer-events-none z-50">
            <div className="container max-md:max-w-full mx-auto sm:px-5 transform duration-300">
                <div className="client-site-header-container flex items-center pl-5 sm:pl-8 pr-4 bg-licorice text-coconut sm:rounded-lg transition-colors duration-500 pointer-events-auto">
                    <a
                        href="https://www.insureworks.co.uk"
                        className="flex-none inline-block text-lg font-semibold"
                        aria-label="Insureworks"
                    >
                        <LogoMark className="icon animated-logo flex-none w-10 lg:w-12 h-10 lg:h-18 text-coconut" />
                    </a>
                </div>
            </div>
        </header>
    );
}
